const initializeFestivalPhotoInfiniteScroll = () => {
    const photoGrid = document.getElementById(
        'festival-photo-grid'
    );

    const paginationContainer =
        document.getElementById(
            'festival-photo-pagination'
        );

    const fallbackPagination =
        document.getElementById(
            'festival-photo-pagination-fallback'
        );

    const statusContainer =
        document.getElementById(
            'festival-photo-load-status'
        );

    const loadingIndicator =
        document.getElementById(
            'festival-photo-loading'
        );

    const errorIndicator =
        document.getElementById(
            'festival-photo-load-error'
        );

    const completeIndicator =
        document.getElementById(
            'festival-photo-load-complete'
        );

    const retryButton =
        document.getElementById(
            'festival-photo-load-retry'
        );

    const sentinel =
        document.getElementById(
            'festival-photo-scroll-sentinel'
        );

    if (
        !photoGrid
        || !paginationContainer
        || !sentinel
    ) {
        return;
    }

    if (!('IntersectionObserver' in window)) {
        return;
    }

    fallbackPagination?.classList.add(
        'hidden'
    );

    statusContainer?.classList.remove(
        'hidden'
    );

    let nextPageUrl =
        paginationContainer.dataset
            .nextPageUrl
        || null;

    let isLoading = false;
    let hasFinished = !nextPageUrl;

    const hideStatusSections = () => {
        loadingIndicator?.classList.add(
            'hidden'
        );

        errorIndicator?.classList.add(
            'hidden'
        );

        completeIndicator?.classList.add(
            'hidden'
        );
    };

    const showLoading = () => {
        hideStatusSections();

        loadingIndicator?.classList.remove(
            'hidden'
        );
    };

    const showError = () => {
        hideStatusSections();

        errorIndicator?.classList.remove(
            'hidden'
        );
    };

    const showComplete = () => {
        hideStatusSections();

        completeIndicator?.classList.remove(
            'hidden'
        );
    };

    const appendPhotos = (html) => {
        const template =
            document.createElement('template');

        template.innerHTML = html.trim();

        const incomingCards = Array.from(
            template.content.querySelectorAll(
                '[data-festival-photo-card]'
            )
        );

        const existingPhotoIds = new Set(
            Array.from(
                photoGrid.querySelectorAll(
                    '[data-festival-photo-card]'
                )
            ).map(
                (card) =>
                    card.dataset
                        .festivalPhotoCard
            )
        );

        incomingCards.forEach((card) => {
            const photoId =
                card.dataset
                    .festivalPhotoCard;

            if (
                !photoId
                || existingPhotoIds.has(photoId)
            ) {
                card.remove();
                return;
            }

            existingPhotoIds.add(photoId);
        });

        photoGrid.append(
            template.content.cloneNode(true)
        );

        document.dispatchEvent(
            new CustomEvent(
                'festival-photos:updated'
            )
        );
    };

    const loadNextPage = async () => {
        if (
            isLoading
            || hasFinished
            || !nextPageUrl
        ) {
            return;
        }

        isLoading = true;
        showLoading();

        try {
            const response = await fetch(
                nextPageUrl,
                {
                    method: 'GET',

                    credentials:
                        'same-origin',

                    headers: {
                        Accept:
                            'application/json',

                        'X-Requested-With':
                            'XMLHttpRequest',
                    },
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Request failed with status ${response.status}.`
                );
            }

            const data =
                await response.json();

            if (
                typeof data.html !== 'string'
                || typeof data.has_more_pages
                    !== 'boolean'
            ) {
                throw new Error(
                    'The server returned an invalid response.'
                );
            }

            if (data.html.trim() !== '') {
                appendPhotos(data.html);
            }

            nextPageUrl =
                data.next_page_url
                || null;

            paginationContainer.dataset
                .nextPageUrl =
                nextPageUrl || '';

            hasFinished =
                !data.has_more_pages
                || !nextPageUrl;

            if (hasFinished) {
                showComplete();
                observer.disconnect();
            } else {
                hideStatusSections();
            }
        } catch (error) {
            console.error(
                'Unable to load additional festival photos:',
                error
            );

            showError();
        } finally {
            isLoading = false;
        }
    };

    const observer =
        new IntersectionObserver(
            (entries) => {
                const sentinelEntry =
                    entries[0];

                if (
                    sentinelEntry
                        ?.isIntersecting
                ) {
                    loadNextPage();
                }
            },
            {
                rootMargin: '700px 0px',
                threshold: 0,
            }
        );

    retryButton?.addEventListener(
        'click',
        loadNextPage
    );

    if (hasFinished) {
        showComplete();
        return;
    }

    observer.observe(sentinel);
};

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        initializeFestivalPhotoInfiniteScroll
    );
} else {
    initializeFestivalPhotoInfiniteScroll();
}